module.exports = __webpack_public_path__ + "media/images/brick-2-0acb172a50dbfd3190096c2f44b652f8.jpg";